import React from 'react';
import { Award, Users, TrendingUp, Target } from 'lucide-react';

const ChiSiamo = () => {
  const features = [
    {
      icon: Award,
      title: 'Serietà e discrezione',
      description: 'Operiamo con riservatezza, professionalità e imparzialità.'
    },
    {
      icon: Users,
      title: 'Rispetto per la storia',
      description: 'Valorizziamo l’identità e il percorso di ogni impresa.'
    },
    {
      icon: TrendingUp,
      title: 'Analisi rigorosa',
      description: 'Esaminiamo numeri, rischi e prospettive con metodo e precisione.'
    },
    {
      icon: Target,
      title: 'Decisioni trasparenti',
      description: 'Agiamo con chiarezza, coerenza e responsabilità verso i partner.'
    }
  ];

  return (
    <section id="chi-siamo" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://images.unsplash.com/photo-1758518728154-d10275e0515e"
                alt="Team professionale Alfa Equity Holding"
                className="rounded-2xl shadow-2xl w-full"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-blue-900 rounded-2xl -z-0 hidden lg:block"></div>
          </div>

          {/* Right Column - Content */}
          <div>
            <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Chi siamo
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Una nuova guida per continuare la storia della vostra impresa
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Siamo professionisti qualificati nel ramo finanziario, con una solida esperienza nei campi della contabilità e della fiscalità. 
              Lavoriamo in modo affidabile e puntuale con imprenditori e famiglie locali affinché possano passare 
              il testimone preservando ciò che hanno costruito, favorendo la tutela delle persone e la crescita sostenibile 
                            delle loro attività.
            </p>

            <p className="text-lg text-gray-600 mb-12 leading-relaxed">
          
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="bg-blue-900 p-3 rounded-lg flex-shrink-0">
                      <Icon className="text-white" size={24} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">{feature.title}</h3>
                      <p className="text-sm text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChiSiamo;